export const RESOURCE_TYPES = Object.freeze({
  video: 'video',
  doc: 'doc',
  exercise: 'exercise',
  project: 'project',
})

export function normalizeLearningResource(resource) {
  if (!resource || typeof resource !== 'object') return null
  const type = RESOURCE_TYPES[resource.type] || RESOURCE_TYPES.doc
  return {
    type,
    title: String(resource.title || ''),
    url: resource.url || '',
    route: resource.route || '',
    stage: resource.stage || '',
    difficulty: resource.difficulty || 'starter',
  }
}

export function resourcesFromLearningStep(step, stage) {
  if (!step) return []
  return [
    {
      type: RESOURCE_TYPES.video,
      title: '视频',
      url: step.videoUrl || '',
      route: '',
      stage: stage?.id || step.stageId || '',
      difficulty: step.difficulty || 'starter',
      description: step.video || '',
    },
    {
      type: RESOURCE_TYPES.doc,
      title: '文档',
      url: '',
      route: step.docRoute || '',
      stage: stage?.id || step.stageId || '',
      difficulty: step.difficulty || 'starter',
      description: step.doc || '',
    },
    {
      type: RESOURCE_TYPES.exercise,
      title: '小练习',
      url: '',
      route: step.exerciseRoute || '/exercise',
      stage: stage?.id || step.stageId || '',
      difficulty: step.difficulty || 'starter',
      description: step.exercise || '',
    },
    {
      type: RESOURCE_TYPES.project,
      title: '推荐项目',
      url: '',
      route: step.projectRoute || '/project',
      stage: stage?.id || step.stageId || '',
      difficulty: step.difficulty || 'starter',
      description: step.project || '',
    },
  ].map(normalizeLearningResourceWithDescription)
}

function normalizeLearningResourceWithDescription(resource) {
  const normalized = normalizeLearningResource(resource)
  return normalized ? { ...normalized, description: resource.description || '' } : null
}
